'use client';
import Chart from 'react-apexcharts';

const DefaultChart = ({ chartDataProps, regime }) => {
	const leitura = chartDataProps.leiturasAmbientes;

	const leituraRegime = regime?.leiturasRegimes || [];
	const options = {
		chart: {
			id: 'basic-line',
			type: 'line',
			dropShadow: {
				enabled: true,
				color: '#123',
				top: 18,
				left: 7,
				blur: 10,
				opacity: 0.5,
			},
			toolbar: {
				show: true,
				tools: {
					download: false,
					selection: false,
					zoom: false,
					zoomin: false,
					zoomout: false,
					pan: false,
					reset: true,
				},

			},
			animations: {
				enabled: false,
				easing: 'easeinout',
				speed: 800,
				animateGradually: {
					enabled: true,
					delay: 150,
				},
				dynamicAnimation: {
					enabled: true,
					speed: 350,
				},
			},
		},
		grid: {
			show: false,
			borderColor: '#40475D',
			strokeDashArray: 0,
		},
		stroke: {
			show: true,
			curve: 'smooth',
			lineCap: 'butt',
			width: 1.2,
			dashArray: 0,
		},
		states: {
			hover: {
				filter: 'none',
			},
		},
		markers: {
			size: 0,
		},
		xaxis: {
			type: 'datetime',
			position: 'bottom',
			labels: {
				formatter: function (val) {
					const date = new Date(val);
					return date.toLocaleTimeString('pt-BR', {
						hour: '2-digit',
						minute: '2-digit',
					});
				  }
,				show: true,
				style: {
					colors: 'rgba(12, 171, 245, 0.30)',
					fontSize: '12px',
					fontStyle: 'normal',
				},
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			axisBorder: {
				show: false,
			},
		},
		yaxis: {
			labels: {
				show: true,
				style: {
					colors: 'rgba(12, 171, 245, 0.30)',
					fontSize: '14px',
				},
				formatter: function (val) {
					const valor = val?.toLocaleString('pt-BR', {
						maximumFractionDigits: 2,
					}) + ' °C';
					return valor;
				},
			},
			axisTicks: {
				show: false,
				color: '#40475D',
			},
			axisBorder: {
				show: false,
			},
		},
		tooltip: {
			theme: 'dark',
		},
		dataLabels: {
			enabled: false,
		},
		legend: {
			show: true,
			position: 'top',
			fontStyle: 'bold',
			fontColor: 'white',
			fontSize: '16px',
			labels: {
				colors: 'white',
				useSeriesColors: false,
			},
			onItemClick: {
				toggleDataSeries: true,
			},
			onItemHover: {
				highlightDataSeries: true,
			},
		},
	};

	let series = [
			{
				name: "temperatura",
				data: leitura.map((leitura) => ([leitura.dataHora, leitura.temperaturaAtual]))
			},
			{
				name: "temperatura referência",
				data: leitura.map((leitura) => ([leitura.dataHora, chartDataProps.temperaturaReferencia]))
			},
			{
				name: "temperatura do regime " + regime?.nome,
				data: leituraRegime.map((leitura) => ([leitura.dataHora, leitura.temperaturaAtual]))
			}
		];


	if (!chartDataProps || regime === undefined ) return null;
	
	return (
		<div className="bg-transparent w-full h-full p-2">
			<Chart
				options={options}
				series={series}
				width="100%"
				height={320}
			/>
		</div>
	);
};

export default DefaultChart;
